import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-RecordO",
  "use": "icon-RecordO-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-RecordO\"><defs><style type=\"text/css\"></style></defs><path d=\"M810.667 254.464L557.355 617.216l2.09 106.752 103.168-28.8 253.355-362.624z m30.336-43.307l42.325-60.629 105.301 78.08-42.41 60.587z\" p-id=\"30052\" fill=\"#FF6633\" /><path d=\"M691.37 717.91l-162.9 45.78-4.737-164.01 302.763-429.227a89.088 89.088 0 0 0-85.461-64.426H148.224a89.387 89.387 0 0 0-89.387 89.386v650.838c0 49.408 40.022 89.429 89.387 89.429h592.81a89.43 89.43 0 0 0 89.43-89.43V520.705L691.371 717.909zM195.457 262.87H554.88a42.24 42.24 0 1 1 0 84.48H195.456a42.24 42.24 0 0 1 0-84.48z m189.099 504.49h-189.1a42.24 42.24 0 1 1 0-84.48h189.099a42.24 42.24 0 1 1 0 84.48z m75.178-210.005H195.456a42.24 42.24 0 0 1 0-84.523h264.277a42.24 42.24 0 1 1 0 84.523z\" p-id=\"30053\" fill=\"#FF6633\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/RecordO.svg
// module id = DATn
// module chunks = 81